import ScenService from "../services/scenarios.service";

const state = () => ({
  favouriteScenarios: [],
  isLoadingFavouriteScenarios: false,
});

const getters = {
  favouriteScenarios(state) {
    return state.favouriteScenarios;
  }
};

const actions = {
  fetchFavouriteScenarios({ commit }) {
    commit("setIsLoading", true);
    ScenService.favouritedScenarios().then(scenarios => {
      commit("setIsLoading", false);
      commit("setFavouriteScenarios", scenarios.map(s => s.scenario));
    });
  },

  removeScenarioFromFavourites({ commit, state }, scenarioUUID) {
    let scenario = state.favouriteScenarios.find(s => s.uuid_id === scenarioUUID);
    if (!scenario) return;

    commit("setIsLoading", true);
    ScenService.toggleFavouriteScenario(scenario.uuid_id).then(() => {
      commit("setIsLoading", false);
      commit("toggleFavouriteScenario", scenario);
    });
  },

  addScenarioToFavourites({ commit, state }, scenario) {
    let scenarioInFaves = state.favouriteScenarios.find(s => s.uuid_id === scenario.uuid_id);
    if (scenarioInFaves) return;

    commit("setIsLoading", true);
    ScenService.toggleFavouriteScenario(scenario.uuid_id).then(() => {
      commit("setIsLoading", false);
      commit("toggleFavouriteScenario", scenario);
    });
  }
};

const mutations = {
  setIsLoading(state, loading) {
    state.isLoadingFavouriteScenarios = loading;
  },

  setFavouriteScenarios(state, scenarios) {
    state.favouriteScenarios = scenarios;
  },

  toggleFavouriteScenario(state, scenario) {
    const idx = state.favouriteScenarios.findIndex(scen => {
      return scen.uuid_id === scenario.uuid_id;
    });

    if (idx !== -1) {
      state.favouriteScenarios.splice(idx, 1);
    } else {
      state.favouriteScenarios.push(scenario);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
